/**
 * 404 page entrance animation.
 *
 * @package HelloElementorChild
 */

import gsap from 'gsap';
import { prefersReducedMotion } from './camst-counter.js';

export function initCamstNotFound(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-not-found]'));
  } else if (scope.matches && scope.matches('[data-camst-not-found]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-not-found]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstNotFoundInit === '1') {
      return;
    }

    root.dataset.camstNotFoundInit = '1';

    var panel = root.querySelector('.camst-not-found__panel');

    if (!panel) {
      return;
    }

    if (prefersReducedMotion()) {
      root.classList.add('is-ready');
      panel.style.opacity = '1';
      panel.style.transform = 'none';
      return;
    }

    gsap.fromTo(
      panel,
      { opacity: 0, scale: 0.95 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: 'power2.out',
        onComplete: function () {
          root.classList.add('is-ready');
          panel.style.transform = '';
        },
      }
    );
  });
}

export function teardownCamstNotFound(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-not-found]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-not-found]'));

  roots.forEach(function (root) {
    delete root.dataset.camstNotFoundInit;
    root.classList.remove('is-ready');
  });
}
